import { styled } from '@mui/material';
import sanitizeHtml from 'sanitize-html';

import { sanitizeOptions } from './utils/sanitizeOptions';
import { WidgetExpandedComponentProps, WidgetHtmlConfigurationType } from '../../../types/widget';

const WidgetHtmlWrapper = styled('div')({
	display: 'flex',
	flex: 1,
});

const ContentWrapper = styled('div')({
	height: '100%',
	border: 0,
});

const ExpandedWidgetHtml = ({ configuration }: WidgetExpandedComponentProps<WidgetHtmlConfigurationType>) => {
	const { html = '<p>Hello World!</p>' } = configuration ?? {};

	return (
		<WidgetHtmlWrapper>
			<ContentWrapper
				dangerouslySetInnerHTML={{
					__html: sanitizeHtml(html, sanitizeOptions),
				}}
			/>
		</WidgetHtmlWrapper>
	);
};

export default ExpandedWidgetHtml;
